{
  "name": "life",
  "version": "0.40.0",
  "description": "Life.js is the first fullstack framework to build agentic web applications. It is minimal, extensible, and typesafe. Well, everything you love.",
  "author": "Lila Rest",
  "license": "MIT+Services",
  "homepage": "https://lifejs.org",
  "bugs": {
    "url": "https://github.com/lifejs/lifejs/issues"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/lifejs/lifejs"
  },
  "files": [
    "dist/",
    "package.json",
    "README.md",
    "LICENSE",
    "LICENSE.SERVICES"
  ],
  "keywords": [
    "react",
    "framework",
    "typescript",
    "fullstack",
    "agents",
    "agentic"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "types": "tsc --noEmit --emitDeclarationOnly false",
    "test": "dotenv -e ../../.env -- vitest run",
    "prepack": "cp ../../README.md README.md && cp ../../LICENSE LICENSE && cp ../../LICENSE.SERVICES LICENSE.SERVICES"
  },
  "bin": {
    "life": "./dist/cli/index.mjs"
  },
  "sideEffects": false,
  "engines": {
    "node": ">=20.0.0"
  },
  "publishConfig": {
    "access": "public"
  },
  "exports": {
    "./config": {
      "import": {
        "types": "./dist/exports/config.d.ts",
        "default": "./dist/exports/config.mjs"
      },
      "require": {
        "types": "./dist/exports/config.d.ts",
        "default": "./dist/exports/config.js"
      }
    },
    "./server": {
      "import": {
        "types": "./dist/exports/server.d.ts",
        "default": "./dist/exports/server.mjs"
      },
      "require": {
        "types": "./dist/exports/server.d.ts",
        "default": "./dist/exports/server.js"
      }
    },
    "./client": {
      "import": {
        "types": "./dist/exports/client.d.ts",
        "default": "./dist/exports/client.mjs"
      },
      "require": {
        "types": "./dist/exports/client.d.ts",
        "default": "./dist/exports/client.js"
      }
    },
    "./react": {
      "import": {
        "types": "./dist/exports/react.d.ts",
        "default": "./dist/exports/react.mjs"
      },
      "require": {
        "types": "./dist/exports/react.d.ts",
        "default": "./dist/exports/react.js"
      }
    }
  },
  "dependencies": {
    "@ast-grep/napi": "^0.39.9",
    "@hono/node-server": "^1.19.6",
    "@hono/node-ws": "^1.2.0",
    "@huggingface/transformers": "^3.7.6",
    "@inkjs/ui": "^2.0.0",
    "@jridgewell/trace-mapping": "^0.3.31",
    "@livekit/rtc-node": "^0.13.20",
    "@nanostores/react": "^1.0.0",
    "@paralleldrive/cuid2": "^3.0.4",
    "@vitest/browser-playwright": "^4.0.8",
    "@zenobius/ink-mouse": "^1.0.3",
    "birpc": "^2.8.0",
    "chalk": "^5.6.2",
    "chokidar": "^4.0.3",
    "commander": "^14.0.2",
    "dotenv": "^17.2.3",
    "error-stack-parser": "^2.1.4",
    "esbuild": "^0.27.0",
    "fast-npm-meta": "^0.4.7",
    "figures": "^6.1.0",
    "globby": "^15.0.0",
    "hono": "^4.10.5",
    "imurmurhash": "^0.1.4",
    "ink": "^6.5.0",
    "ink-link": "^5.0.0",
    "livekit-client": "^2.15.15",
    "livekit-server-sdk": "^2.14.0",
    "mathjax-full": "^3.2.2",
    "mdast-flatten-nested-lists": "^1.2.0",
    "mdast-util-from-markdown": "^2.0.2",
    "mdast-util-gfm": "^3.1.0",
    "mdast-util-math": "^3.0.0",
    "mdast-util-mdx-jsx": "^3.2.0",
    "mdast-util-to-markdown": "^2.1.2",
    "micromark-extension-gfm": "^3.0.0",
    "micromark-extension-math": "^3.1.0",
    "micromark-extension-mdx-jsx": "^3.0.2",
    "nanostores": "^1.0.1",
    "onnxruntime-node": ">=1.24.0-0",
    "oxc-parser": "^0.97.0",
    "oxc-walker": "^0.5.2",
    "react": "^19.2.0",
    "resolve": "^1.22.11",
    "serialize-error": "^12.0.0",
    "speech-rule-engine": "^5.0.0-alpha.8",
    "string-width": "^8.1.0",
    "superjson": "^2.2.5",
    "to-words": "^4.8.0",
    "ua-parser-js": "^2.0.5",
    "wrap-ansi": "^9.0.2",
    "yjs": "^13.6.27",
    "zod": "^4.1.12"
  },
  "devDependencies": {
    "@cartesia/cartesia-js": "^2.2.9",
    "@deepgram/sdk": "4.11.2",
    "@mistralai/mistralai": "^1.10.0",
    "@playwright/test": "^1.56.1",
    "@types/imurmurhash": "^0.1.4",
    "@types/mdast": "^4.0.4",
    "@types/node": "^24.10.1",
    "@types/react": "^19.2",
    "@types/react-dom": "^19.2",
    "@types/resolve": "^1.20.6",
    "@types/ws": "^8.18.1",
    "@vitest/browser": "^4.0.8",
    "dotenv-cli": "^11.0.0",
    "esbuild-plugin-preserve-directives": "^0.0.11",
    "openai": "^5.20.2",
    "playwright": "^1.56.1",
    "tsup": "^8.5.0",
    "type-fest": "^5.2.0",
    "vitest": "^4.0.8"
  },
  "peerDependencies": {
    "@cartesia/cartesia-js": "^2.2.5",
    "@deepgram/sdk": "4.9.1",
    "@mistralai/mistralai": "^1.7.4",
    "openai": "^5.9.0"
  },
  "peerDependenciesMeta": {
    "@cartesia/cartesia-js": {
      "optional": true
    },
    "@deepgram/sdk": {
      "optional": true
    },
    "@mistralai/mistralai": {
      "optional": true
    },
    "openai": {
      "optional": true
    }
  }
}
